exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".version-header[data-v-3ede9784]{display:flex}\n", ""]);

